var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { isUsdt0Code } from "const";
import { fetchTransaction } from "helpers/fetchTransaction";
import { getPaymentStatusChannel, usePaymentStatusPusher, } from "hooks/useDepositStatusPusher";
import { FALLBACK_POLL_MS, usePolling } from "hooks/usePolling";
import { capture } from "lib/analytics";
import { ROZO_EVENTS } from "lib/analytics/events";
import { useEffect, useRef, useState } from "react";
import { getAmountIn, getAmountInAsset, getAmountOut, getAmountOutAsset, getDepositTokenCode, } from "types";
import TxnInfoBlock from "../components/TxnInfoBlock";
export var Status = function (_a) {
    var _b, _c;
    var txnInfo = _a.txnInfo, sessionToken = _a.sessionToken, onTxnInfoUpdate = _a.onTxnInfoUpdate;
    var _d = useState((_b = txnInfo === null || txnInfo === void 0 ? void 0 : txnInfo.transaction) !== null && _b !== void 0 ? _b : null), info = _d[0], setInfo = _d[1];
    var lastTrackedStatusRef = useRef(null);
    var latestInfoRef = useRef((_c = txnInfo === null || txnInfo === void 0 ? void 0 : txnInfo.transaction) !== null && _c !== void 0 ? _c : null);
    useEffect(function () {
        if ((txnInfo === null || txnInfo === void 0 ? void 0 : txnInfo.transaction) &&
            JSON.stringify(latestInfoRef.current) !==
                JSON.stringify(txnInfo.transaction)) {
            latestInfoRef.current = txnInfo.transaction;
            setInfo(txnInfo.transaction);
        }
    }, [txnInfo]);
    // Track status transitions (real-time via Pusher, polling as fallback)
    var trackStatus = function (transaction, via) {
        var status = transaction.status;
        if (lastTrackedStatusRef.current === status)
            return;
        lastTrackedStatusRef.current = status;
        capture(ROZO_EVENTS.STATUS_UPDATE_RECEIVED, {
            transaction_kind: transaction.kind,
            transaction_id: transaction.id,
            transaction_status: status,
            via: via,
        });
        if (status === "completed") {
            capture(ROZO_EVENTS.PAYMENT_COMPLETED, {
                transaction_kind: transaction.kind,
                transaction_id: transaction.id,
                amount_in: getAmountIn(transaction),
                amount_out: getAmountOut(transaction),
            });
        }
        else if (status === "error") {
            capture(ROZO_EVENTS.PAYMENT_FAILED, {
                transaction_kind: transaction.kind,
                transaction_id: transaction.id,
                transaction_status: status,
            });
        }
        else if (status === "expired") {
            capture(ROZO_EVENTS.TRANSACTION_EXPIRED, {
                transaction_kind: transaction.kind,
                transaction_id: transaction.id,
            });
        }
    };
    var updateInfo = function (tx, via) {
        var _a;
        if (JSON.stringify(latestInfoRef.current) === JSON.stringify(tx)) {
            trackStatus(tx, via);
            return;
        }
        var statusChanged = ((_a = latestInfoRef.current) === null || _a === void 0 ? void 0 : _a.status) !== tx.status;
        latestInfoRef.current = tx;
        setInfo(tx);
        if (statusChanged)
            onTxnInfoUpdate === null || onTxnInfoUpdate === void 0 ? void 0 : onTxnInfoUpdate({ transaction: tx });
        trackStatus(tx, via);
    };
    var endStatus = ["completed", "error", "expired"];
    var isWithdrawal = (info === null || info === void 0 ? void 0 : info.kind) === "withdrawal";
    var isUsdt0Transfer = Boolean(info &&
        (isUsdt0Code(getDepositTokenCode(info)) ||
            isUsdt0Code(getAmountInAsset(info)) ||
            isUsdt0Code(getAmountOutAsset(info))));
    var pusherChannelName = getPaymentStatusChannel(info);
    usePaymentStatusPusher({
        channelName: pusherChannelName,
        logPrefix: isWithdrawal ? "[withdraw:pusher]" : "[deposit:pusher]",
        onAny: function (e) { return __awaiter(void 0, void 0, void 0, function () {
            var txnResponse, tx, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        console.log("pusher event", e);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, fetchTransaction(sessionToken)];
                    case 2:
                        txnResponse = _b.sent();
                        tx = txnResponse === null || txnResponse === void 0 ? void 0 : txnResponse.transaction;
                        if (tx) {
                            updateInfo(tx, "pusher");
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        _a = _b.sent();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); },
    });
    usePolling({
        pollFn: function () { return __awaiter(void 0, void 0, void 0, function () {
            var txnResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetchTransaction(sessionToken)];
                    case 1:
                        txnResponse = _a.sent();
                        return [2 /*return*/, txnResponse === null || txnResponse === void 0 ? void 0 : txnResponse.transaction];
                }
            });
        }); },
        shouldStop: function (transaction) {
            return endStatus.includes(transaction.status);
        },
        // With a Pusher channel the poll is only a fallback, and each poll makes
        // the backend query Rozo, so slow it down; before that, poll fast.
        interval: pusherChannelName ? FALLBACK_POLL_MS : 2000,
        enabled: !!sessionToken &&
            (!info ||
                info.status === "incomplete" ||
                // Withdrawals and USDT0 transfers keep polling as fallback: a missed
                // Pusher event otherwise leaves the page on its last status.
                ((isWithdrawal || isUsdt0Transfer) &&
                    !endStatus.includes(info.status))),
        immediate: true,
        onData: function (transaction) {
            if (transaction) {
                updateInfo(transaction, "polling");
            }
        },
    });
    if (!sessionToken || !info) {
        return (_jsxs("div", { className: "StatusBootstrapLoader", role: "status", "aria-live": "polite", children: [_jsx("div", { className: "StatusBootstrapLoader__spinner", "aria-hidden": true }), _jsx("h3", { className: "StatusBootstrapLoader__title", children: "Loading Transaction" })] }));
    }
    return (_jsx("div", { className: "PageTransition", children: _jsx(TxnInfoBlock, { info: info }) }));
};
